var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 15H4C2.9 15 2 14.1 2 13V7C2 5.9 2.9 5 4 5H20C21.1 5 22 5.9 22 7V13C22 14.1 21.1 15 20 15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6V4H10V6H8V4C8 2.9 8.9 2 10 2H14C15.1 2 16 2.9 16 4V6H14ZM20 15H4C2.9 15 2 14.1 2 13V11C3.1 11 4 11.9 4 13H10V12H14V13H20C20 11.9 20.9 11 22 11V13C22 14.1 21.1 15 20 15ZM14 12V13H10V12H14ZM2 13V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V13C20.9 13 20 13.9 20 15H14V16H10V15H4C4 13.9 3.1 13 2 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.060bfa595b95624e16769fa609cf1972.svg";
export { ForwardRef as ReactComponent };